(function () {
  const btn = document.getElementById("LensPersonalizeBtn");
  const modal = document.getElementById("LensPersonalizerModal");
  if (!btn || !modal) return;

  // 1) RENSEIGNE ICI les variant IDs des produits suppléments
  const LENS_ADDON_VARIANT_IDS = {
    unicolor: 15354254295388,   // Supplément unicolores (39€)
    bicolor: 15354255868252,    // Supplément bicolores (49€)
    transition: 15354255180124, // Supplément transition (69€)
    polarised: 15354257178972,  // Supplément polarisés (49€)
  };

  // 2) LISTES (tes options)
  const OPTIONS = {
    unicolor: ["Blaune","Colorado","Coriandre","Eucalyptus","Golf","Vert petrole","Terracota","Vert G ray"],
    bicolor: ["GARDEN","GRIOTTINE","LAGON","AUBERGINE","BLACKBERRY","CALANQUES","PAON","ECLIPSE","VERONESE","CERULEEN","CHATAIGNE","RAISIN"],
    transition: ["BRUN","GRIS","AMBRE","VERT GRAPHITE","BLEU SAPHIR","VERT EMERAUDE","RUBIS","VIOLET AMETHYSTE"],
    polarised: ["VERT","GRIS","VERT GRAPHITE"],
  };
  const IMAGE_MAP = {
  unicolor: {
    "Blaune": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/unicolore-blaune.webp?v=1766585574",
    "Colorado": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/unicolore-colorado.webp?v=1766585590",
    "Coriandre": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/unicolore-Coriandre.webp?v=1766585468",
    "Eucalyptus": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/unicolore-eucalyptus.webp?v=1766585504",
    "Golf": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/unicolore-golf.webp?v=1766587493",
    "Vert petrole": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/unicolore-vert-petrole.webp?v=1766585554",
    "Terracota": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/unicolore-terracota.webp?v=1766585484",
    "Vert G ray": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/unicolore-vert-g-ray.webp?v=1766585412",
  },
  bicolor: {
    "GARDEN": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-garden.webp?v=1766586430",
    "GRIOTTINE": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-grillottine.webp?v=1766586824",
    "LAGON": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-lagon.webp?v=1766586852",
    "AUBERGINE": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-aubergine.webp?v=1766585629",
    "BLACKBERRY": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-blackberry.webp?v=1766585645",
    "CALANQUES": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-calanques.webp?v=1766585667",
    "PAON": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-paon.webp?v=1766586872",
    "ECLIPSE": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-eclipse.webp?v=1766586112",
    "VERONESE": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-veronese.webp?v=1766585707",
    "CERULEEN": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-ceruleen.webp?v=1766586782",
    "CHATAIGNE": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-chataigne.webp?v=1766586095",
    "RAISIN": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/bicolore-raisin.webp?v=1766586288",
  },
  transition: {
    "BRUN": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/transition-brun.png?v=1766587094",
    "GRIS": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/transition-gris.png?v=1766586988",
    "AMBRE": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/transition-ambre.png?v=1766587063",
    "VERT GRAPHITE": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/transition-vert-graphite.png?v=1766587122",
    "BLEU SAPHIR": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/transition-saphire.png?v=1766587018",
    "VERT EMERAUDE": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/transition-emeraude.png?v=1766586937",
    "RUBIS": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/transition-rubis.webp?v=1766586908",
    "VIOLET AMETHYSTE": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/transition-amethyste.png?v=1766587165",
  },
  polarised: {
    "VERT": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/polarise-vert.webp?v=1766587257",
    "GRIS": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/polarise-gris.webp?v=1766587286",
    "VERT GRAPHITE": "https://cdn.shopify.com/s/files/1/0900/6268/4508/files/polarise-brun.webp?v=1766587227",
  }
};


  const PRICE_LABEL = {
    unicolor: "+39€",
    bicolor: "+49€",
    transition: "+69€",
    polarised: "+49€",
  };

  const closeEls = modal.querySelectorAll("[data-close]");
  const step1 = document.getElementById("LensStep1");
  const step2 = document.getElementById("LensStep2");
  const step3 = document.getElementById("LensStep3");
  const optionsWrap = document.getElementById("LensOptions");
  const step2Title = document.getElementById("LensStep2Title");
  const summary = document.getElementById("LensSummary");

  let state = { type: null, option: null };

  function openModal() {
  // ✅ sortir le modal du layout produit (Dawn stacking context)
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  modal.hidden = false;
  document.body.classList.add("lens-modal-open");
  panel?.focus?.();
}


  function reset() {
    state = { type: null, option: null };
    step1.hidden = false;
    step2.hidden = true;
    step3.hidden = true;
    optionsWrap.innerHTML = "";
    summary.innerHTML = "";
  }

  function closeModal() {
    modal.hidden = true;
    reset();
  }

  btn.addEventListener("click", openModal);
  closeEls.forEach((el) => el.addEventListener("click", closeModal));

  // Step 1: type
  step1.addEventListener("click", (e) => {
    const type = e.target?.dataset?.lensType;
    if (!type) return;

    state.type = type;

    step2Title.textContent = `${titleFor(type)} (${PRICE_LABEL[type] || ""})`;

    const choices = OPTIONS[type] || [];
    optionsWrap.innerHTML = choices.map((label) => {
  const img = IMAGE_MAP?.[type]?.[label] || "";
  return `
    <label class="lens-card">
      <input type="radio" name="lens_option" value="${escapeHtml(label)}">
      <span class="lens-card__media">
        ${img ? `<img src="${img}" alt="${escapeHtml(label)}" loading="lazy">` : ``}
      </span>
      <span class="lens-card__label">${escapeHtml(label)}</span>
    </label>
  `;
}).join("");


    step1.hidden = true;
    step2.hidden = false;
  });

  document.getElementById("LensBack").addEventListener("click", () => {
    step2.hidden = true;
    step1.hidden = false;
  });

  // Step 2 -> Step 3
  document.getElementById("LensNext").addEventListener("click", () => {
    const selected = modal.querySelector('input[name="lens_option"]:checked');
    if (!selected) return alert("Choisissez une option de verres.");
    state.option = selected.value;

    const productTitle =
      document.querySelector(".product__title")?.textContent?.trim() || "Lunettes de soleil";

    summary.innerHTML = `
      <p><strong>${escapeHtml(productTitle)}</strong></p>
      <p>Type de verres : <strong>${escapeHtml(titleFor(state.type))}</strong> <span class="lens-pill">${escapeHtml(PRICE_LABEL[state.type] || "")}</span></p>
      <p>Option : <strong>${escapeHtml(state.option)}</strong></p>
      <p>Délai : <strong>+7 jours</strong></p>
    `;

    step2.hidden = true;
    step3.hidden = false;
  });

  document.getElementById("LensEdit").addEventListener("click", () => {
    step3.hidden = true;
    step2.hidden = false;
  });

  // Add bundle to cart: lunettes + supplément
  document.getElementById("LensAddBundle").addEventListener("click", async () => {
    // Dawn product form variant input (même sans variantes, il y a un variant)
    const variantId = document.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
    if (!variantId) return alert("Impossible de récupérer l’article. Recharge la page.");

    const addonId = LENS_ADDON_VARIANT_IDS[state.type];
    if (!addonId) return alert("Supplément verres non configuré (ID manquant).");

    const propsForGlasses = {
      "Type de verres": titleFor(state.type),
      "Option verres": state.option,
      "Délai verres": "+7 jours",
    };

    const propsForAddon = {
      "Supplément": `Verres ${titleFor(state.type)} – ${state.option}`,
      "Délai verres": "+7 jours",
      "Associer à": "Lunettes de soleil",
    };

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
  items: [
    { id: Number(variantId), quantity: 1, properties: propsForGlasses },
    { id: Number(addonId), quantity: 1, properties: propsForAddon },
  ],
        }),
});

if (!res.ok) {
  const data = await res.json().catch(async () => ({ description: await res.text() }));
  console.error("Shopify cart error:", data);
  alert("Erreur ajout panier : " + (data.description || JSON.stringify(data)));
  return;
}

      // Ouvrir le cart drawer Dawn si présent
      document.querySelector("cart-drawer")?.open?.();
      closeModal();
    } catch (err) {
      console.error(err);
      alert("Une erreur est survenue. Réessayez.");
    }
  });

  function titleFor(type) {
    return (
      {
        unicolor: "Unicolores",
        bicolor: "Bicolores",
        transition: "Transition",
        polarised: "Polarisés",
      }[type] || type
    );
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (s) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#039;",
    })[s]);
  }
})();

